(() => {
  'use strict';
  const selector = '[data-clearance-color-cards]';
  function init(section) {
    const grid = section.querySelector('[data-grid-item]')?.parentElement;
    if (!grid || grid.dataset.colorsReady) return;
    grid.dataset.colorsReady = "true";
    section.dataset.colorsReady = 'true';
    const groups = new Map();

    section.querySelectorAll('[data-grid-item]').forEach((card, collectionIndex) => {
      // Preserve the exact Shopify collection order for every card.
      card.style.order = String(collectionIndex);

      if (card.hasAttribute('data-ac-split-color-card')) return;

      const title = card.querySelector('.product-item__title');
      const full = title?.textContent.trim();
      if (!full) return;

      // Match the store's "Design In Color" naming convention.
      const match = full.match(/^(.*?)\s+in\s+(.+?)(\s+-\s+.*)?$/i);
      const design = match ? match[1].trim() + (match[3] || '') : full;
      const color = match ? match[2].trim() : full;
      const key = card.dataset.siblingGroup || design.toLowerCase();
      const entries = groups.get(key) || [];

      entries.push({
        card,
        title,
        design,
        color,
        collectionIndex
      });

      groups.set(key, entries);
    });

    groups.forEach(entries => {
      // Keep the sibling group at its first Shopify collection position.
      const groupOrder = Math.min(
        ...entries.map(entry => entry.collectionIndex)
      );

      entries.forEach(entry => {
        entry.card.style.order = String(groupOrder);
      });
      if (entries.length < 2) { entries[0].title.textContent = entries[0].design; return; }
      const rank = entry => /warm skin/i.test(entry.color) ? 1 : /soft skin/i.test(entry.color) ? 2 : /black/i.test(entry.color) ? 4 : 3;
      let active = entries.reduce((best, entry) => rank(entry) < rank(best) ? entry : best);
      // Read the native sibling order before replacing its markup. Use the
      // initially selected product as the source so every color shares one order.
      const productHandle = url => {
        const match = (url || '').match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      };
      const siblingOrder = new Map();
      (active.card.dataset.siblingOrder || '').split(',').filter(Boolean).forEach((handle, index) => siblingOrder.set(handle, index));
      active.card.querySelectorAll('[data-sibling-link]').forEach(swatch => {
        const handle = productHandle(swatch.getAttribute('data-sibling-link'));
        if (handle && !siblingOrder.has(handle)) siblingOrder.set(handle, siblingOrder.size);
      });
      const orderedEntries = entries.map((entry, index) => {
        const link = entry.card.querySelector('a[data-product-link]');
        const handle = productHandle(link?.getAttribute('href'));
        return { entry, index, order: siblingOrder.has(handle) ? siblingOrder.get(handle) : Infinity };
      }).sort((a, b) => a.order - b.order || a.index - b.index).map(item => item.entry);
      // Select the first clearance product in the displayed sibling order.
      active = orderedEntries[0];
      entries.forEach(entry => {
        entry.card.hidden = true;
        entry.card.classList.add('clearance-grouped-card');
        entry.title.textContent = entry.design;
        const holder = document.createElement('div');
        const shape = section.dataset.clearanceSwatchStyle === 'square' ? 'square' : 'circle';
        holder.className = `clearance-native-swatches product-item__siblings product-item__swatches__holder product-item__swatches__holder--${shape} product-item__swatches__holder--grid`;
        const fieldset = document.createElement('div');
        fieldset.className = 'radio__fieldset radio__fieldset--swatches radio__fieldset--pgi is-visible';
        const controls = document.createElement('div');
        controls.className = 'selector-wrapper__scrollbar clearance-colors';
        fieldset.append(controls);
        holder.append(fieldset);
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', `${entry.design} colors`);
        orderedEntries.forEach(target => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'clearance-color sibling__link' + (target === entry ? ' sibling__link--current' : '');
          button.title = target.color;
          button.setAttribute('aria-label', target.color);
          button.setAttribute('aria-pressed', String(target === entry));
          const colorKey = target.color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const swatch = document.createElement('span');
          const shape = section.dataset.clearanceSwatchStyle === 'square' ? 'square' : 'circle';
          swatch.className = `swatches swatch__button swatch__button--${shape} swatch-${colorKey}`;
          // Reuse the exact theme color map, including its fabric swatch files.
          // Standard CSS color names cover Cornsilk, Teal, Light Coral, etc.
          const cssColor = target.color.replace(/\s+/g, '');
          const fallback = CSS.supports('color', cssColor) ? cssColor : 'transparent';
          swatch.style.setProperty('--swatch', `var(--${colorKey}, ${fallback})`);
          swatch.append(button);
          button.addEventListener('click', () => {
            if (active === target) return;
            active.card.hidden = true;
            active = target;
            active.card.hidden = false;
            // Existing theme animations must not leave a switched card faded.
            active.card.querySelectorAll('[data-aos]').forEach(node => node.classList.add('aos-animate'));
            const selected = active.card.querySelector('.clearance-color[aria-pressed="true"]');
            selected?.focus({preventScroll: true});
          });
          controls.append(swatch);
        });
        // Use the original native swatch slot inside the padded info block.
        // Appending to product-information puts swatches 20px left of titles.
        const nativeSlot = entry.card.querySelector('.product-item__swatches__holder:not(.clearance-native-swatches)');
        const info = entry.card.querySelector('.product-item__info');
        if (nativeSlot) {
          nativeSlot.replaceWith(holder);
        } else if (info) {
          const productLink = info.querySelector('a[data-product-link]');
          if (productLink) productLink.after(holder);
          else info.append(holder);
        } else {
          entry.card.append(holder);
        }
      });
      active.card.hidden = false;
    });
  }
  function hideUnavailableSplitSwatches(root) {
    root
      .querySelectorAll(
        '[data-ac-split-color-card] grid-swatch'
      )
      .forEach(gridSwatch => {
        const card = gridSwatch.closest('[data-grid-item]');
        const collectionHandles = (
          card?.dataset.limoniappsDiscountninjaProductCollections || ''
        )
          .split(',')
          .map(handle => handle.trim());

        // Apply sold-out colour hiding only to clearance products.
        if (!collectionHandles.includes('clearance-collection')) return;

        const product = gridSwatch.product;
        const colorOption = gridSwatch.colorOption;

        if (!product || !colorOption) return;

        const colorIndex = product.options.findIndex(
          option =>
            option.name.toLowerCase() ===
            colorOption.name.toLowerCase()
        );

        if (colorIndex < 0) return;

        gridSwatch
          .querySelectorAll('[data-swatch-button]')
          .forEach(button => {
            const color = button.dataset.tooltip;

            const colorAvailable = product.variants.some(
              variant =>
                variant.available &&
                variant.options[colorIndex] === color
            );

            button.hidden = !colorAvailable;

            if (colorAvailable) {
              button.style.removeProperty('display');
            } else {
              button.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });
      });
  }

  function scan(root) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
    hideUnavailableSplitSwatches(root);
  }

  scan(document);

  let scheduled = false;

  new MutationObserver(records => {
    const relevantChange = records.some(record =>
      [...record.addedNodes].some(node =>
        node.nodeType === 1 &&
        (
          node.matches?.(
            '[data-grid-item], [data-clearance-color-cards], [data-swatch-button]'
          ) ||
          node.querySelector?.(
            '[data-grid-item], [data-swatch-button]'
          )
        )
      )
    );

    if (scheduled || !relevantChange) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      scan(document);
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  if (!window.adelaisClearanceColorsRegistered) {
    window.adelaisClearanceColorsRegistered = true;
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
})();
